import script from "./HeadCont.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadCont.vue?vue&type=script&setup=true&lang=js"

import "./HeadCont.vue?vue&type=style&index=0&id=268a3d5e&lang=scss&scoped=true"
import "./HeadCont.vue?vue&type=style&index=1&id=268a3d5e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268a3d5e"]])

export default __exports__